import React from 'react'
import { type LucideProps } from 'lucide-react'

const MirroredTitanium: React.FC<LucideProps> = (props: LucideProps) => (
  <svg
  width={30}
  height={19}
  viewBox="0 0 30 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  {...props}
>
  <rect
    x="29.7209"
    y="18.4877"
    width="29.42"
    height={18}
    rx={1}
    transform="rotate(180 29.7209 18.4877)"
    fill="url(#pattern0_1323_5564)"
  />
  <defs>
    <pattern
      id="pattern0_1323_5564"
      patternContentUnits="objectBoundingBox"
      width={1}
      height={1}
    >
      <use
        xlinkHref="#image0_1323_5564"
        transform="matrix(0.00134077 0 0 0.00215748 -0.589881 -0.515954)"
      />
    </pattern>
    <image
      id="image0_1323_5564"
      width={1600}
      height={900}
      xlinkHref="data:image/jpeg;base64,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"
    />
  </defs>
</svg>

)

export default MirroredTitanium
